import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../api/client';

export default function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      const path = window.location.pathname;
      const actMatch = path.match(/^\/activity\/([^/]+)$/);
      if (actMatch) {
        navigate(`/activity/${actMatch[1]}/preview`);
      } else {
        const dest = path + window.location.search;
        navigate(`/login?redirect=${encodeURIComponent(dest)}`);
      }
      return;
    }

    // Verify token by checking current user
    authAPI.getMe()
      .then(() => setIsAuthenticated(true))
      .catch((err) => {
        // Only log out on a definitive auth rejection (401/403), not network errors
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('userId');
          navigate('/login');
        } else {
          // Transient error — trust the token and let them in
          setIsAuthenticated(true);
        }
      });
  }, [navigate]);

  if (isAuthenticated === null) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;
  }

  return isAuthenticated ? children : null;
}
